//チェックボックスの値を配列に格納する関数
const checkBoxValue = (name) =>{
	let checkValue = [];
	document.getElementsByName(name).forEach(check =>{
		if(check.checked) {
			checkValue.push(check.value);
		}
	});
	return checkValue;
}
//指定の要素の「is-glnw-acitve」を取り除く関数
const initElements = (elements) => {
	elements.forEach(element => {
		element.classList.remove("is-glnw-active");
	});
}


const $checkBoxes = document.querySelectorAll(".glnw-checkbox");
$checkBoxes.forEach($checkBox =>{
	$checkBox.addEventListener("change",e => {
		//console.log(e.currentTarget);
		e.currentTarget.classList.toggle("is-checked");
	});
});

//地域を選択するチェックボックスの処理
const $regions = document.getElementsByName("regions");
for(let i = 0 ; i < $regions.length ; i ++ ) {
	$regions[i].addEventListener('change' , event => {
		let regionArray = [];
		for (let i = 0; i < $regions.length; i++) {
			if ( $regions[i].checked) {
				regionArray.push($regions[i].value);
			}
		}
		regionFilter(regionArray);
	});
}
const regionFilter = (array) => {
	let regionActiveFlag = false;
	//一旦すべてを非表示化
	initElements( document.querySelectorAll(".glnw-region") );

	if(array.length != 0 ) {
		//同じデータ属性の要素にis-glnw-activeを付与
		let regionChildren = null;
		for(let i = 0; i < array.length ; i++) {
			regionChildren = document.querySelector('[data-region="'+ array[i] +'"]').children;
			for( let j = 0; j < regionChildren.length ; j++) {
				if(regionChildren.item(j).classList.contains("is-glnw-active")) {
					regionActiveFlag = true;
				}
			}
			if(regionActiveFlag) {
				document.querySelector('[data-region="'+ array[i] +'"]').classList.add("is-glnw-active");
			}
		}

	} else {
		//空の場合はすべての要素を表示
		document.querySelectorAll(".glnw-region").forEach($regionBlock => {
			$regionBlock.classList.add("is-glnw-active");
		});
		bizFilterRegion();

	}
	checkResult();
}

//ビジネスを選択するチェックボックス
const $businesses = document.getElementsByName("businesses");
//各企業情報を表示している要素
const $companyBlocks = document.querySelectorAll(".glnw-company");

for(let i = 0 ; i < $businesses.length ; i ++ ) {
	$businesses[i].addEventListener('change' , event => {
		let businessArray = [];
		for (let i = 0; i < $businesses.length; i++) {
			if ( $businesses[i].checked) {
				businessArray.push($businesses[i].value);
			}
		}
		bizFilter(businessArray);
	});
}

//ビジネスのフィルター処理
const bizFilter = (array) => {
	initElements( document.querySelectorAll(".glnw-company") );
	if(array.length != 0) {
		for(let i = 0; i < array.length ; i++) {
			document.querySelectorAll(".glnw-company").forEach($companyBlock =>{
				if($companyBlock.classList.contains(array[i])) {
					$companyBlock.classList.add("is-glnw-active");
				}
			});
		}
	} else {
		//チェックボックスが空の場合はすべての要素を表示
		document.querySelectorAll(".glnw-company").forEach($companyBlock => {
			$companyBlock.classList.add("is-glnw-active");
		});
	}

	//ビジネス名によるフィルタリングしたあとに
	//地域名によるフィルターを実行する
	let regionvalue = checkBoxValue("regions");
	regionFilter(regionvalue);

	//表示結果を確認する
	checkResult();
}
const bizFilterRegion = () => {
	document.querySelectorAll(".glnw-region").forEach(region => {
		region.classList.remove("is-glnw-active");
		const companies = Array.from(region.children);
		companies.forEach(company =>{
			if(company.classList.contains("is-glnw-active")) {
				region.classList.add("is-glnw-active");
			}
		});
	});

}

//該当する企業が一つもなければエラーメッセージを表示
const checkResult = () => {
	const $errorDom = document.getElementById("glnw-error");
	if( document.querySelectorAll(".is-glnw-active").length === 0 ||
		document.querySelectorAll(".glnw-region.is-glnw-active").length === 0 ) {
		$errorDom.innerHTML = "<p>There is no match for the choose.</p>";
	} else {
		$errorDom.innerHTML = null;
	}
}
